import { createSelector } from '@ngrx/store';
import { deviceIdFilter } from 'src/app/utils/functions/store.functions';
import { IDevicesState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';

export const selectDevicesStore = (state: IRemoteXPACPortalState) => state.devices;

export const selectDevices = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.devices
);

export const selectMapDevices = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.mapDevices
);

export const selectDevicesQuery = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.devicesQuery
);

export const selectUpgradeDevices = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.upgradeDevices
);

export const selectXpacDevices = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.crossNetDevices)
);

export const selectRestoreDevices = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.restoreDevicesXpac)
);

export const selectDeviceLogging = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.deviceLogging)
);

export const selectDeviceProblems = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.currentDeviceProblems)
);

export const selectCompanyInfo = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.xpacCompanyInfo)
);

export const selectRemoteConnections = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.remoteConnections)
);

export const selectDeviceConnections = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.currentDeviceConnections)
);

export const selectStoreInfo = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.detailedXpacInfo)
);

export const selectTelemetry = (deviceId: string) => createSelector(
  selectDevicesStore,
  (state: IDevicesState) => deviceIdFilter(deviceId, state.telemetry)?.telemetry
);

export const selectDevicesPermissions = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.permission
);

export const selectLocationAutocompleteData = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.getLocationAutocompleteData
);

export const selectCurrentAutocompleteAddress = createSelector(
  selectDevicesStore,
  (state:IDevicesState) => state.currentAutocompleteAddress
);

export const selectFirmwareReleases = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.firmwareReleases
);

export const selectFirmwareUpdateStatus = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.deploymentStatus
);

export const selectDeviceFirmware = createSelector(
  selectDevicesStore,
  (state: IDevicesState) => state.deviceFirmware
);